import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuArrowRight } from 'react-icons/lu';
import useInView from '../hooks/useInView';

export default function HomeFinalCta() {
  const navigate = useNavigate();
  const [ref, inView] = useInView();

  return (
    <section ref={ref} className={`hfc${inView ? ' in-view' : ''}`}>
      <div className="hfc-container">
        <h2 className="hfc-title">
          Stop paying<br />
          the <span className="hfc-accent">SMS tax.</span>
        </h2>
        <p className="hfc-sub">
          Connect your first SIM in five minutes. No credit card, no A2P paperwork.
        </p>
        <div className="hfc-ctas">
          <button className="hfc-btn-primary" onClick={() => navigate('/signup')}>
            Try for free
            <LuArrowRight size={16} strokeWidth={2} />
          </button>
          <button className="hfc-btn-secondary" onClick={() => navigate('/pricing')}>
            See pricing
          </button>
        </div>
        <p className="hfc-foot">
          Or <a href="/ghl">set up GoHighLevel</a> in 60 seconds.
        </p>
      </div>

      <style jsx>{`
        .hfc {
          background: #ffffff;
          padding: clamp(7rem, 16vh, 13rem) clamp(1rem, 3vw, 2rem);
          font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #000;
          -webkit-font-smoothing: antialiased;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .hfc::before {
          content: "";
          position: absolute;
          inset: auto 0 0 0;
          height: 70%;
          background:
            radial-gradient(ellipse 80% 60% at 50% 100%, rgba(167, 139, 250, 0.22), transparent 70%);
          pointer-events: none;
          z-index: 0;
        }
        .hfc-container {
          max-width: 780px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        /* scroll reveal */
        .hfc-title, .hfc-sub, .hfc-ctas, .hfc-foot {
          opacity: 0;
          translate: 0 14px;
          transition: opacity 650ms cubic-bezier(0.16, 1, 0.3, 1), translate 650ms cubic-bezier(0.16, 1, 0.3, 1);
        }
        .hfc.in-view .hfc-title { opacity: 1; translate: 0 0; }
        .hfc.in-view .hfc-sub   { opacity: 1; translate: 0 0; transition-delay: 100ms; }
        .hfc.in-view .hfc-ctas  { opacity: 1; translate: 0 0; transition-delay: 200ms; }
        .hfc.in-view .hfc-foot  { opacity: 1; translate: 0 0; transition-delay: 300ms; }

        .hfc-title {
          font-size: clamp(2.75rem, 8vw, 5.5rem);
          font-weight: 600;
          letter-spacing: -0.05em;
          line-height: 0.98;
          margin: 0 0 1.5rem;
          color: #000;
        }
        .hfc-accent {
          background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .hfc-sub {
          font-size: clamp(1rem, 1.6vw, 1.1875rem);
          color: rgba(0,0,0,0.6);
          margin: 0 auto clamp(2rem, 4vh, 3rem);
          line-height: 1.55;
          max-width: 480px;
        }
        .hfc-ctas {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 1.5rem;
        }
        .hfc-btn-primary {
          background: #0a0a0a;
          color: #ffffff;
          border: none;
          border-radius: 10px;
          padding: 0.875rem 1.625rem;
          font-size: 0.9375rem;
          font-weight: 500;
          font-family: inherit;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          transition: background 160ms ease, transform 120ms ease;
          letter-spacing: -0.005em;
        }
        .hfc-btn-primary:hover {
          background: #27272a;
          transform: translateY(-1px);
        }
        .hfc-btn-secondary {
          background: transparent;
          color: #000;
          border: 1px solid rgba(0,0,0,0.14);
          border-radius: 10px;
          padding: 0.875rem 1.5rem;
          font-size: 0.9375rem;
          font-weight: 500;
          font-family: inherit;
          cursor: pointer;
          transition: background 140ms ease, border-color 140ms ease;
          letter-spacing: -0.005em;
        }
        .hfc-btn-secondary:hover {
          background: #fafafa;
          border-color: rgba(0,0,0,0.28);
        }

        .hfc-foot {
          font-size: 0.875rem;
          color: rgba(0,0,0,0.5);
          margin: 0;
        }
        .hfc-foot a {
          color: #6d28d9;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        @media (max-width: 560px) {
          .hfc-ctas { width: 100%; flex-direction: column; gap: 0.625rem; }
          .hfc-btn-primary, .hfc-btn-secondary { width: 100%; justify-content: center; }
        }
      `}</style>
    </section>
  );
}
